import React from 'react';
import './MenuButtons.css';

const MenuButtons = () => {
  return (
    <span className='MenuButtons' >
      {/* <I18nButton /> */}
    </span>
  );
};

export default MenuButtons;
